var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _feGaussianBlur, _feGaussianBlur2, _feGaussianBlur3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg34074",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 299.99969 182.63284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs34071"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient13835"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#1e0505",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop13821"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#2b2b2b",
      stopOpacity: 1
    },
    offset: 0.14630227,
    id: "stop13823"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#383838",
      stopOpacity: 1
    },
    offset: 0.3002412,
    id: "stop13825"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#454545",
      stopOpacity: 1
    },
    offset: 0.44774917,
    id: "stop13827"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5f5f5f",
      stopOpacity: 1
    },
    offset: 0.60000002,
    id: "stop13829"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#676767",
      stopOpacity: 1
    },
    offset: 0.7512058,
    id: "stop13831"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#4d4d4d",
      stopOpacity: 1
    },
    offset: 0.90032154,
    id: "stop13833"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient13019"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccc",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop13015"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9a9a",
      stopOpacity: 1
    },
    offset: 0.2,
    id: "stop13087"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#828282",
      stopOpacity: 1
    },
    offset: 0.40000001,
    id: "stop13089"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "gray",
      stopOpacity: 1
    },
    offset: 0.60000002,
    id: "stop13091"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9a9a9a",
      stopOpacity: 1
    },
    offset: 0.80000001,
    id: "stop13093"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ccc",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop13017"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6155"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5f7fd",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop6143"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#cffbff",
      stopOpacity: 1
    },
    offset: 0.2,
    id: "stop6145"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#65acff",
      stopOpacity: 1
    },
    offset: 0.40000001,
    id: "stop6147"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#2b8eb9",
      stopOpacity: 1
    },
    offset: 0.60000002,
    id: "stop6149"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d5f2fc",
      stopOpacity: 1
    },
    offset: 0.80000001,
    id: "stop6151"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dbecf9",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop6153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5320"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop5316"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop5318"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4467"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#000",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop4463"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#442f2f",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop4465"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient58375"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#1e0505",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop58361"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#2b2b2b",
      stopOpacity: 1
    },
    offset: 0.14630227,
    id: "stop58363"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#383838",
      stopOpacity: 1
    },
    offset: 0.3002412,
    id: "stop58365"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#505050",
      stopOpacity: 1
    },
    offset: 0.44774917,
    id: "stop58367"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7b7b7b",
      stopOpacity: 1
    },
    offset: 0.60000002,
    id: "stop58369"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#848484",
      stopOpacity: 1
    },
    offset: 0.7512058,
    id: "stop58371"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a8a8a8",
      stopOpacity: 1
    },
    offset: 0.90032154,
    id: "stop58373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient55441"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#333",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop55437"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#656565",
      stopOpacity: 1
    },
    offset: 0.20096463,
    id: "stop55445"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#989898",
      stopOpacity: 1
    },
    offset: 0.39951769,
    id: "stop55447"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a6a6a6",
      stopOpacity: 1
    },
    offset: 0.60000002,
    id: "stop55449"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b2b2b2",
      stopOpacity: 1
    },
    offset: 0.80000001,
    id: "stop55451"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#373737",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop55439"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient31314",
    id: "linearGradient31318",
    x1: 134.83498,
    y1: 185.42915,
    x2: 171.70763,
    y2: 185.42915,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.85603 0 0 .21525 -891.44499 65.911536)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient31314"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9d9d9",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop31302"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b2b2b2",
      stopOpacity: 1
    },
    offset: 0.14630227,
    id: "stop31304"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "gray",
      stopOpacity: 1
    },
    offset: 0.3002412,
    id: "stop31306"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#989898",
      stopOpacity: 1
    },
    offset: 0.44774917,
    id: "stop31308"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0b0b0",
      stopOpacity: 1
    },
    offset: 0.60000002,
    id: "stop31310"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b2b2b2",
      stopOpacity: 1
    },
    offset: 0.7512058,
    id: "stop46591"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#d9d9d9",
      stopOpacity: 1
    },
    offset: 0.90032154,
    id: "stop31312"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient31314",
    id: "linearGradient47325",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.85603 0 0 .21525 -891.44499 86.17827)",
    x1: 134.83498,
    y1: 185.42915,
    x2: 171.70763,
    y2: 185.42915
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient31314-8",
    id: "linearGradient31318-3",
    x1: 134.83498,
    y1: 185.42915,
    x2: 171.70763,
    y2: 185.42915,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.45433 0 0 1.37184 -20.173735 -108.90012)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient31314-8"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c40d84",
      stopOpacity: 1
    },
    offset: 0.07717042,
    id: "stop31302-1"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b0007e",
      stopOpacity: 1
    },
    offset: 0.24919616,
    id: "stop31304-5"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#840056",
      stopOpacity: 1
    },
    offset: 0.40956593,
    id: "stop31306-3"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7e1f51",
      stopOpacity: 1
    },
    offset: 0.61816716,
    id: "stop31308-5"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b423a1",
      stopOpacity: 1
    },
    offset: 0.77893889,
    id: "stop31310-4"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e749ac",
      stopOpacity: 1
    },
    offset: 0.95498395,
    id: "stop31312-3"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient31314-8",
    id: "linearGradient53925",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.45433 0 0 1.37184 91.889386 -108.90012)",
    x1: 134.83498,
    y1: 185.42915,
    x2: 171.70763,
    y2: 185.42915
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient55441",
    id: "linearGradient55443",
    x1: 1.3459922,
    y1: 42.827023,
    x2: 44.540104,
    y2: 42.582298,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.2476 0 0 3.2476 31.579744 29.244184)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient13835",
    id: "linearGradient57633",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.07029 0 0 2.94482 -88.977972 -336.2635)",
    x1: 134.83498,
    y1: 185.42915,
    x2: 171.70763,
    y2: 185.42915
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient58375",
    id: "linearGradient63507",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.1769 0 0 .48519 247.09651 45.206259)",
    x1: 134.83498,
    y1: 185.42915,
    x2: 171.70763,
    y2: 185.42915
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient58375",
    id: "linearGradient65694",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.1769 0 0 .48519 133.79843 95.616408)",
    x1: 134.83498,
    y1: 185.42915,
    x2: 171.70763,
    y2: 185.42915
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient58375",
    id: "linearGradient67150",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-.1769 -.0001 .00025 -.48519 73.186549 185.72676)",
    x1: 134.83498,
    y1: 185.42915,
    x2: 171.70763,
    y2: 185.42915
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient4467",
    id: "linearGradient4469",
    x1: -14.093669,
    y1: 37.786476,
    x2: 9.023778,
    y2: 37.786476,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient5320",
    id: "linearGradient5322",
    x1: 18.173168,
    y1: 50.459732,
    x2: 75.920914,
    y2: 50.459732,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient6155",
    id: "linearGradient6889",
    x1: 60.482689,
    y1: 68.449326,
    x2: 68.568336,
    y2: 68.449326,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-59.168916 -41.648769)"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient6155",
    id: "linearGradient7732",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-24.743365 -41.95614)",
    x1: 60.482689,
    y1: 68.449326,
    x2: 68.568336,
    y2: 68.449326
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient6155",
    id: "linearGradient7736",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.5285004 -41.95614)",
    x1: 60.482689,
    y1: 68.449326,
    x2: 68.568336,
    y2: 68.449326
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient13019",
    id: "linearGradient13021",
    x1: 241.86053,
    y1: 206.93997,
    x2: 299.10614,
    y2: 200.60178,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient13019",
    id: "linearGradient13967",
    gradientUnits: "userSpaceOnUse",
    x1: 241.86053,
    y1: 206.93997,
    x2: 299.10614,
    y2: 200.60178
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient13019",
    id: "linearGradient13971",
    gradientUnits: "userSpaceOnUse",
    x1: 241.86053,
    y1: 206.93997,
    x2: 299.10614,
    y2: 200.60178
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient13019",
    id: "linearGradient13975",
    gradientUnits: "userSpaceOnUse",
    x1: 241.86053,
    y1: 206.93997,
    x2: 299.10614,
    y2: 200.60178
  })), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter2452",
    x: -0.04808204,
    y: -0.01923738,
    width: 1.0914854,
    height: 1.0359296
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.16322064,
    id: "feGaussianBlur2454"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter5312",
    x: -0.01313241,
    y: -0.03404956,
    width: 1.0294596,
    height: 1.0708497
  }, _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22473666,
    id: "feGaussianBlur5314"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter6883",
    x: -0.06888009,
    y: -0.11902527,
    width: 1.1377602,
    height: 1.2380505
  }, _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2142071,
    id: "feGaussianBlur6885"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "stark",
    transform: "translate(14.132399 -71.677137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6139",
    style: {
      mixBlendMode: "normal",
      fill: "url(#linearGradient6889)",
      fillOpacity: 1,
      strokeWidth: 0.160907,
      filter: "url(#filter6883)"
    },
    d: "M5.3848505 24.64094a3.7035945.58488556 0 0 0-3.680688.524853h-.02285V28.315143h.02285a3.7035945.58488556 0 0 0-.02285.05997 3.7035945.58488556 0 0 0 3.703556.585053 3.7035945.58488556 0 0 0 3.703552-.585053 3.7035945.58488556 0 0 0-.02331-.05997h.02331V25.165793h-.02331a3.7035945.58488556 0 0 0-3.680262-.524853Zm-3.760082.584824.05653 3.179565z",
    transform: "matrix(3.2476 0 0 4.64766 31.579742 -8.0283791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7730",
    style: {
      mixBlendMode: "normal",
      fill: "url(#linearGradient7732)",
      fillOpacity: 1,
      strokeWidth: 0.160907,
      filter: "url(#filter6883)"
    },
    d: "M39.810401 24.333569a3.7035945.58488556 0 0 0-3.680688.524853h-.02285V28.007772h.02285a3.7035945.58488556 0 0 0-.02285.05997 3.7035945.58488556 0 0 0 3.703556.585053 3.7035945.58488556 0 0 0 3.703552-.585053 3.7035945.58488556 0 0 0-.02331-.05997h.02331V24.858422h-.02331a3.7035945.58488556 0 0 0-3.680262-.524853zm-3.760082.584824.05653 3.179565z",
    transform: "matrix(1.24925 0 0 3.80763 102.59385 14.906579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7734",
    style: {
      mixBlendMode: "normal",
      fill: "url(#linearGradient7736)",
      fillOpacity: 1,
      strokeWidth: 0.160907,
      filter: "url(#filter6883)"
    },
    d: "M74.082266 24.333569a3.7035945.58488556 0 0 0-3.680688.524853h-.02285V28.007772h.02285a3.7035945.58488556 0 0 0-.02285.05997 3.7035945.58488556 0 0 0 3.703556.585053 3.7035945.58488556 0 0 0 3.703552-.585053 3.7035945.58488556 0 0 0-.02331-.05997h.02331V24.858422h-.02331a3.7035945.58488556 0 0 0-3.680262-.524853zm-3.760082.584824.05653 3.179565z",
    transform: "matrix(3.2476 0 0 4.46099 31.579742 -2.652474)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#linearGradient5322)",
      strokeWidth: 1.32292,
      strokeDasharray: ".661458,.661458",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      filter: "url(#filter5312)"
    },
    d: "m75.00504 34.509531-5.993736 4.149508-4.610566 3.07371-4.456877 4.45688-7.22322 5.378992-5.378992 3.073709-5.686362 3.07371-7.376903 3.381081-7.991647 2.920024-7.376903 2.305283",
    id: "path5310",
    transform: "matrix(3.2476 0 0 3.2476 31.579743 29.244182)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#linearGradient4469)",
      strokeWidth: 1.32292,
      strokeDasharray: ".661458,.661458",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      filter: "url(#filter2452)"
    },
    d: "m4.3031939 18.74963-5.6863633-4.76425-5.5326777.614742-3.9958229 4.149508-2.151597 6.454791 1.075799 7.223219 3.0737093 8.452702 5.0716214 8.913757 7.530589 6.45479 4.3031939 5.532679",
    id: "path2342",
    transform: "matrix(3.2476 0 0 3.2476 31.579743 29.244182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path67148",
    style: {
      fill: "url(#linearGradient67150)",
      fillOpacity: 1,
      strokeWidth: 0.277227
    },
    d: "M46.054951 105.07526a7.6948347.70235672.02993193 0 0 7.648106-.62535l.04699.00003.000036-.0721.0019-3.71061-.04699-.00002a7.6948347.70235672.02993193 0 0 .04703-.0721 7.6948347.70235672.02993193 0 0-4.423532-.636687l.0049-9.356234-.02011-.000009a3.2368325 1.9865112.02993193 0 0 .02011-.203059 3.2368325 1.9865112.02993193 0 0-3.236305-1.988739 3.2368325 1.9865112.02993193 0 0-3.2367 1.98536 3.2368325 1.9865112.02993193 0 0 .02011.203059l-.02011-.000009-.0049 9.352881a7.6948347.70235672.02993193 0 0-4.493004.635377 7.6948347.70235672.02993193 0 0 .04865.0722l-.04868-.00002-.0019 3.7106-.000039.0721.04868.00002a7.6948347.70235672.02993193 0 0 7.64577.63333zm7.812611-.69743-.115484-3.81807z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65692",
    style: {
      fill: "url(#linearGradient65694)",
      fillOpacity: 1,
      strokeWidth: 0.277227
    },
    d: "M160.97217 176.25372a7.6948347.70235672 0 0 0-7.64779.62933h-.0469V180.66575h.0469a7.6948347.70235672 0 0 0-.0469.0722 7.6948347.70235672 0 0 0 4.42387.63438v9.35623h.0202a3.2368325 1.9865112 0 0 0-.0202.20305 3.2368325 1.9865112 0 0 0 3.23734 1.98706 3.2368325 1.9865112 0 0 0 3.23567-1.98706 3.2368325 1.9865112 0 0 0-.0202-.20305h.0202v-9.35288a7.6948347.70235672 0 0 0 4.49267-.63773 7.6948347.70235672 0 0 0-.0486-.0722h.0486V176.88305h-.0486a7.6948347.70235672 0 0 0-7.64608-.62933zm-7.81225.7015.11746 3.81801z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63505",
    style: {
      fill: "url(#linearGradient63507)",
      fillOpacity: 1,
      strokeWidth: 0.277227
    },
    d: "M274.27022 125.84356a7.6948347.70235672 0 0 0-7.64778.62935h-.0469v3.78271h.0469a7.6948347.70235672 0 0 0-.0469.0721 7.6948347.70235672 0 0 0 4.42387.63438v9.35624h.0202a3.2368325 1.9865112 0 0 0-.0202.20305 3.2368325 1.9865112 0 0 0 3.23733 1.98705 3.2368325 1.9865112 0 0 0 3.23567-1.98705 3.2368325 1.9865112 0 0 0-.0202-.20305h.0202v-9.35289a7.6948347.70235672 0 0 0 4.49267-.63773 7.6948347.70235672 0 0 0-.0486-.0721h.0486v-3.78271h-.0486a7.6948347.70235672 0 0 0-7.64609-.62935zm-7.81225.70151.11746 3.81802z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57631",
    style: {
      fill: "url(#linearGradient57633)",
      fillOpacity: 1,
      strokeWidth: 1.67991
    },
    d: "M75.215554 165.27274a19.58285 12.056984 0 0 0-19.461738 10.81946h-.12078v64.9213h.12078a19.58285 12.056984 0 0 0-.12078 1.23605 19.58285 12.056984 0 0 0 19.582648 12.06043 19.58285 12.056984 0 0 0 19.582635-12.06043 19.58285 12.056984 0 0 0-.123287-1.23605h.123287v-64.9213h-.123287a19.58285 12.056984 0 0 0-19.459439-10.81946Zm-19.881537 12.05572.298896 65.54435z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53921",
    style: {
      fill: "url(#linearGradient53925)",
      fillOpacity: 1,
      strokeWidth: 0.747037
    },
    d: "M161.58867 124.74075a8.3128194 5.6167507 0 0 0-8.2614 5.04024h-.0512v30.24371h.0512a8.3128194 5.6167507 0 0 0-.0512.57592 8.3128194 5.6167507 0 0 0 8.31273 5.61834 8.3128194 5.6167507 0 0 0 8.31274-5.61834 8.3128194 5.6167507 0 0 0-.0523-.57592h.0523v-30.24371h-.0523a8.3128194 5.6167507 0 0 0-8.26047-5.04024zm-8.4396 5.61614.12689 30.53387z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31294-6",
    style: {
      fill: "url(#linearGradient31318-3)",
      fillOpacity: 1,
      strokeWidth: 0.747037
    },
    d: "M49.525567 124.74075a8.3128194 5.6167507 0 0 0-8.261406 5.04024h-.05127v30.24371h.05127a8.3128194 5.6167507 0 0 0-.05127.57592 8.3128194 5.6167507 0 0 0 8.312733 5.61834 8.3128194 5.6167507 0 0 0 8.312727-5.61834 8.3128194 5.6167507 0 0 0-.05231-.57592h.05231v-30.24371h-.05231a8.3128194 5.6167507 0 0 0-8.26045-5.04024zm-8.439609 5.61614.126883 30.53387z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31294",
    style: {
      fill: "url(#linearGradient31318)",
      fillOpacity: 1,
      strokeWidth: 1.14952
    },
    d: "M160.34518 102.57117a125.44374.88130156 0 0 0-124.667896.79085h-.773726V108.10746h.773726a125.44374.88130156 0 0 0-.773726.0904 125.44374.88130156 0 0 0 125.442422.88156 125.44374.88130156 0 0 0 125.44237-.88156 125.44374.88130156 0 0 0-.78958-.0904h.78958V103.36202h-.78958a125.44374.88130156 0 0 0-124.6533-.79085zm-127.357046.88122 1.914672 4.79093z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47323",
    style: {
      fill: "url(#linearGradient47325)",
      fillOpacity: 1,
      strokeWidth: 1.14952
    },
    d: "M160.34518 122.8379a125.44374.88130156 0 0 0-124.667896.79085h-.773726v4.74546h.773726a125.44374.88130156 0 0 0-.773726.0904 125.44374.88130156 0 0 0 125.442422.88156 125.44374.88130156 0 0 0 125.44237-.88156 125.44374.88130156 0 0 0-.78958-.0904h.78958v-4.74546h-.78958a125.44374.88130156 0 0 0-124.6533-.79085zm-127.357046.88121 1.914672 4.79095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient55443)",
      fillOpacity: 1,
      strokeWidth: 1.28,
      strokeOpacity: 0.740425
    },
    id: "rect55435",
    d: "M35.156223 160.38187h141.07234v18.677187H35.156223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient13021)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.323,
      strokeDasharray: ".661498,.661498",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path12227",
    d: "m285.78242 228.2774-21.94378 5.34656-19.29718-11.736-5.34656-21.94378 11.736-19.29718 21.94378-5.34656 19.29718 11.73601 5.34656 21.94377z",
    transform: "matrix(.18697 .03922 -.04285 .1947 19.495878 147.15793)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient13967)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.323,
      strokeDasharray: ".661498,.661498",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path13965",
    d: "m285.78242 228.2774-21.94378 5.34656-19.29718-11.736-5.34656-21.94378 11.736-19.29718 21.94378-5.34656 19.29718 11.73601 5.34656 21.94377z",
    transform: "matrix(.18697 .03922 -.04285 .1947 19.495878 180.59833)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient13971)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.323,
      strokeDasharray: ".661498,.661498",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path13969",
    d: "m285.78242 228.2774-21.94378 5.34656-19.29718-11.736-5.34656-21.94378 11.736-19.29718 21.94378-5.34656 19.29718 11.73601 5.34656 21.94377z",
    transform: "matrix(.18697 .03922 -.04285 .1947 46.447838 147.15793)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#linearGradient13975)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.323,
      strokeDasharray: ".661498,.661498",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path13973",
    d: "m285.78242 228.2774-21.94378 5.34656-19.29718-11.736-5.34656-21.94378 11.736-19.29718 21.94378-5.34656 19.29718 11.73601 5.34656 21.94377z",
    transform: "matrix(.18697 .03922 -.04285 .1947 46.447838 179.60011)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStark);
export default __webpack_public_path__ + "static/media/stark.0da7da974fc9855f8de68668608b8c85.svg";
export { ForwardRef as ReactComponent };